import React from 'react';
import { Globe } from 'lucide-react';
import WebAnalyticsCard from '../../components/WebAnalyticsCard';

export const meta = {
  id: 'web_analytics',
  category: 'business',
  titleKey: 'dashboard.widgets.webAnalytics',
  descriptionKey: 'dashboard.widgets.webAnalyticsDesc',
  defaultSize: 'xl',
  minRole: 'admin',
  icon: Globe,
};

export default function WebAnalyticsWidget() {
  return <WebAnalyticsCard />;
}
